import { useTranslation } from "react-i18next";
import LyfeFormField from "../../../components/LyfeFormField";

const Language = () => {
	const { t } = useTranslation();
	const languageOptions = [
		{ label: t("en-US"), value: "en-US" },
		{ label: t("de"), value: "de" },
	];
	return (
		<LyfeFormField
			name="preferredLanguage"
			fullWidth
			label={t("language-preferences")}
			required
			select
			options={languageOptions}
		/>
	);
};

export default Language;
